// Streaming-ish SHA-256 in the browser. Web Crypto's digest() takes a
// full ArrayBuffer, so we slurp the file with arrayBuffer() and hash it
// in one go. Files up to ~100 MB fit comfortably in memory; if we ever
// raise the cap we'd want to switch to chunked hashing via an offscreen
// worker, but v1 doesn't need it.
export async function sha256OfFile(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return bufferToHex(digest);
}

function bufferToHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let hex = '';
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return hex;
}
